(() => {
  if (!customElements.get('coverly-collection-header')) {
    customElements.define('coverly-collection-header', class extends HTMLElement {
      connectedCallback() {
        this.main = this.closest('main');
        this.button = this.querySelector('[data-collection-filters-toggle]');
        this.media = matchMedia('(min-width: 990px)');
        this.setOpen = open => {
          if (!this.main || !this.button) return;
          this.main.dataset.pricedFilters = open ? 'open' : 'closed';
          this.button.setAttribute('aria-expanded', String(open));
        };
        this.reset = () => this.setOpen(this.media.matches);
        this.toggle = () => this.setOpen(this.button.getAttribute('aria-expanded') !== 'true');
        this.escape = event => {
          if (event.key === 'Escape' && !this.media.matches && this.button.getAttribute('aria-expanded') === 'true') {
            this.setOpen(false);
            this.button.focus();
          }
        };
        this.button?.addEventListener('click', this.toggle);
        this.main?.addEventListener('keydown', this.escape);
        this.media.addEventListener('change', this.reset);
        this.reset();
      }
      disconnectedCallback() {
        this.button?.removeEventListener('click', this.toggle);
        this.main?.removeEventListener('keydown', this.escape);
        this.media?.removeEventListener('change', this.reset);
      }
    });
  }
  if (!customElements.get('coverly-collection-story')) {
    customElements.define('coverly-collection-story', class extends HTMLElement {
      connectedCallback() {
        const applyDefault = () => {
          const viewer = this.querySelector('[data-ppo-standalone]');
          if (viewer && !viewer.dataset.defaultProduct) viewer.dataset.defaultProduct = this.dataset.viewerDefault;
        };
        applyDefault();
        this.observer = new MutationObserver(applyDefault);
        this.observer.observe(this, {childList: true, subtree: true});
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }
})();
